import React, { useEffect, useRef } from "react";
import { Marker, Popup, Polyline } from "react-leaflet";
import L from "leaflet";

const roadClosedIcon = L.divIcon({
  className: "",
  html: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="filter: drop-shadow(0 1px 2px rgba(0,0,0,0.6));">
    <polygon points="7.5,1.5 16.5,1.5 22.5,7.5 22.5,16.5 16.5,22.5 7.5,22.5 1.5,16.5 1.5,7.5"
      fill="#C1121F" stroke="#0A0D0C" stroke-width="1.5" stroke-linejoin="round"/>
    <rect x="4.5" y="10" width="15" height="4" rx="1" fill="#FFFFFF"/>
  </svg>`,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
  popupAnchor: [0, -11],
});

const roadCautionIcon = L.divIcon({
  className: "",
  html: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="filter: drop-shadow(0 1px 2px rgba(0,0,0,0.6));">
    <path d="M12 2 L22 20 L2 20 Z" fill="#F59E0B" stroke="#0A0D0C" stroke-width="1.5" stroke-linejoin="round"/>
    <rect x="11" y="8" width="2.4" height="6" rx="1" fill="#0A0D0C"/>
    <circle cx="12.2" cy="17" r="1.4" fill="#0A0D0C"/>
  </svg>`,
  iconSize: [24, 24],
  iconAnchor: [12, 14],
  popupAnchor: [0, -12],
});

const STATUS_META = {
  closed: { label: "ROAD CLOSED", color: "#C1121F", icon: roadClosedIcon, dash: null },
  caution: { label: "ROAD UPDATE", color: "#F59E0B", icon: roadCautionIcon, dash: "8 6" },
  detour: { label: "DETOUR", color: "#3B82F6", icon: roadCautionIcon, dash: "2 8" },
};

function lineLatLngs(geometry) {
  if (!geometry) return null;
  if (geometry.type === "MultiLineString")
    return geometry.coordinates.map((path) => path.map(([x, y]) => [y, x]));
  if (geometry.type === "LineString")
    return [geometry.coordinates.map(([x, y]) => [y, x])];
  return null;
}

function ClosurePopup({ c, meta }) {
  return (
    <Popup>
      <div style={{ minWidth: 180 }}>
        <div style={{ fontWeight: 700, color: meta.color, fontSize: 12 }}>
          {meta.label} · COUNTY EM
        </div>
        <div style={{ fontWeight: 700, fontSize: 13, margin: "3px 0" }}>
          {c.name}
          {c.milepost != null ? ` · MP ${c.milepost}` : ""}
        </div>
        {c.description && (
          <div style={{ fontSize: 12, whiteSpace: "pre-line" }}>{c.description}</div>
        )}
      </div>
    </Popup>
  );
}

export default function RoadClosuresLayer({ closures = [], focusClosure = null }) {
  const markerRefs = useRef({});
  useEffect(() => {
    if (!focusClosure?.id) return;
    const t = setTimeout(() => markerRefs.current[focusClosure.id]?.openPopup(), 900);
    return () => clearTimeout(t);
  }, [focusClosure]);
  return (
    <>
      {closures.map((c) => {
        const meta = STATUS_META[c.status] || STATUS_META.closed;
        const lines = lineLatLngs(c.geometry);
        return (
          <React.Fragment key={c.id}>
            {lines &&
              lines.map((positions, i) => (
                <Polyline
                  key={`${c.id}-line-${i}`}
                  positions={positions}
                  pathOptions={{
                    color: meta.color,
                    weight: 5,
                    opacity: 0.85,
                    dashArray: meta.dash,
                  }}
                >
                  <ClosurePopup c={c} meta={meta} />
                </Polyline>
              ))}
            <Marker
              position={[c.latitude, c.longitude]}
              icon={meta.icon}
              ref={(r) => { markerRefs.current[c.id] = r; }}
            >
              <ClosurePopup c={c} meta={meta} />
            </Marker>
          </React.Fragment>
        );
      })}
    </>
  );
}
